import { ExternalOffer } from 'state/loyalty/types';

export const parseExternalIncentiveData = (incentive: ExternalOffer, isOfferClosed: boolean) => {
  // If unauthenticated user content is not configured in Sanity,
  // we will default to closed content regardless of whether it is a closed offer or not
  const incentiveData = {
    title:
      (isOfferClosed
        ? incentive.title?.locale
        : incentive.unauthenticatedUsersContent?.title?.locale) ?? incentive.title?.locale,
    subtitle: incentive.subtitle,
    description:
      (isOfferClosed
        ? incentive.description?.localeRaw
        : incentive.unauthenticatedUsersContent?.description?.localeRaw) ??
      incentive.description?.localeRaw,
    image: incentive?.image,
    buttonsConfiguration: incentive?.buttonsConfiguration,
    unauthenticatedUsersContent: incentive?.unauthenticatedUsersContent,
    externalOfferModal: incentive?.externalOfferModal,
  };

  return {
    id: incentive?._id,
    backgroundImage: incentive?.backgroundImage,

    ...incentiveData,
  };
};
